module.exports = __webpack_public_path__ + "img/icon-sb-katapult-logo.e3cad65.svg";